import React from 'react';
import DropDown from '@ocp/dropdown';
const DropDownList = ({ items }) => (React.createElement(React.Fragment, null, items.map((item) => (React.createElement(DropDown.Item, { key: item.title, onClick: item.onClick }, item.title)))));
export default DropDownList;
